import { Empty, Modal, Pagination } from 'antd';
import React from 'react';
import SkuListCard from './SkuListCard';
import './skuStyle.scss';
import { useState } from 'react';
import { useEffect } from 'react';

const SkuListModal = ({ skuModal, closeSkuModal, skuData }) => {
    const [paginationData, setPaginationData] = useState({
        currentPage: 1,
        size: 10,
    });
    const [dataToShow, setDataToShow] = useState([]);
    let offset = 0;
    useEffect(() => {
        let tempData = [...skuData];
        offset = (paginationData.currentPage - 1) * paginationData.size;
        let sortedList = tempData?.splice(offset, paginationData.size);
        setDataToShow(sortedList);

        return () => setDataToShow([]);
    }, [paginationData]);
    return (
        <Modal
            title={`SKU LIST`}
            open={skuModal?.flag}
            onCancel={closeSkuModal}
            closable
            footer={null}
            //   onOk={() => OnFormSubmit(BaysList)}
            width="90%"
            style={{
                top: '15px',
                height: '85vh',
            }}
        >
            <div className="skuCards_container">
                {skuData && skuData?.length > 0 ? (
                    dataToShow?.map(elm => <SkuListCard key={elm?.skuName} skuName={elm?.skuName} img={elm?.article?.articleImage} />)
                ) : (
                    <Empty style={{ margin: '120px auto auto' }} />
                )}
            </div>
            {skuData && skuData?.length > 0 && (
                <Pagination
                    style={{ textAlign: 'center', marginTop: 5 }}
                    current={paginationData.currentPage}
                    onChange={(page, size) => setPaginationData({ currentPage: page, size: size })}
                    total={skuData?.length}
                />
            )}
        </Modal>
    );
};

export default SkuListModal;
